module.exports = __webpack_public_path__ + "static/media/Juan Mateo - copia.0b61286f.jpg";